export default function WhyUs() {
  const reasons = [
    {
      icon: 'ri-shield-check-line',
      title: '確かな技術力',
      description: '業務用エアコンの専門知識を持つプロフェッショナルが、最新の技術と機材を使用して高品質なサービスを提供します。',
      color: 'bg-cyan-500',
      image: 'https://readdy.ai/api/search-image?query=Professional%20technician%20with%20certification%20badge%20working%20on%20commercial%20air%20conditioning%20system%2C%20wearing%20clean%20uniform%2C%20modern%20office%20environment%20with%20white%20and%20blue%20tones%2C%20professional%20equipment%20visible%2C%20high%20quality%20business%20photography%2C%20clean%20and%20organized%20workspace&width=600&height=400&seq=why-tech-001&orientation=landscape'
    },
    {
      icon: 'ri-time-line',
      title: '迅速な対応',
      description: 'お問い合わせから現地調査、作業完了まで、スピーディーな対応で業務への影響を最小限に抑えます。緊急時も24時間対応可能です。',
      color: 'bg-lime-500',
      image: 'https://readdy.ai/api/search-image?query=Fast%20response%20team%20arriving%20at%20commercial%20building%20with%20service%20van%2C%20professional%20technicians%20ready%20for%20quick%20air%20conditioning%20service%2C%20modern%20corporate%20environment%2C%20white%20and%20blue%20color%20scheme%2C%20efficient%20and%20organized%2C%20business%20photography%20style&width=600&height=400&seq=why-speed-001&orientation=landscape'
    },
    {
      icon: 'ri-hand-coin-line',
      title: 'コストパフォーマンス',
      description: '定期メンテナンスによる故障予防で、長期的なコスト削減を実現。明確な料金体系で、予算に応じた最適なプランをご提案します。',
      color: 'bg-yellow-500',
      image: 'https://readdy.ai/api/search-image?query=Cost%20effective%20air%20conditioning%20maintenance%20plan%20document%20with%20calculator%20and%20charts%2C%20professional%20business%20setting%2C%20clean%20white%20desk%20with%20blue%20accents%2C%20financial%20planning%20for%20HVAC%20services%2C%20organized%20and%20professional%2C%20business%20photography&width=600&height=400&seq=why-cost-001&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-cyan-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-cyan-100 text-cyan-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Why Choose Us
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            法人依頼が多い<span className="text-cyan-600">3つの理由</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            多くの企業様に選ばれ続ける、私たちの強み
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={reason.image}
                  alt={reason.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                <div className={`absolute top-4 right-4 ${reason.color} w-12 h-12 flex items-center justify-center rounded-full shadow-lg`}>
                  <i className={`${reason.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center mb-3">
                  <span className="text-4xl font-bold text-cyan-600 mr-3">0{index + 1}</span>
                  <h3 className="text-xl font-bold text-slate-800">
                    {reason.title}
                  </h3>
                </div>
                <p className="text-slate-600 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
